import React from "react";
import { OrderContainer } from "./style";
import { getSecondPayments } from "api/product";
import Loading from "components/loading";
import EmptyState from "components/emptyState";
import NumberFormat from "components/numberFormat";
const OrdersPage = () => {
  const [orders, setOrders] = React.useState(null);
  React.useLayoutEffect(() => {
    if (orders === null)
      getSecondPayments()
        .then((res) => {
          console.log(res.data);
          setOrders(res.data.items);
        })
        .catch((err) => {});
  }, [orders]);
  if (orders === null) {
    return <Loading />;
  }
  return (
    <OrderContainer>
      {orders.length > 0 ? (
        orders.map((order, index) => (
          <div className="order" key={index}>
            <div className="item order-title">{order.title}</div>
            <div className="item order-amount">
              {NumberFormat({ value: order.amount })}
            </div>
            <div className="item order-status">{order.status}</div>
            <div className="item order-actions">
              <a href={order?.link.url}>{order?.link.title}</a>
            </div>
          </div>
        ))
      ) : (
        <EmptyState message="موردی جهت نمایش یافت نشد" />
      )}
    </OrderContainer>
  );
};
export default OrdersPage;
